import { defineMessages } from 'react-intl';

export default defineMessages({
  index: {
    id: 'frontbucket.workspace.settings.breadcrumbs.index',
    description: 'Text to display for workspace settings index breadcrumb link',
    defaultMessage: 'Workspace settings',
  },
});
